export default class Cta {
  constructor($el) {
    this.$anchor = $el
    this.$anchor.addEventListener('click', (e) => {
      e.preventDefault();
      window.top.location.href = this.$anchor.href
    })
  }
}